import { IAdmin } from "../../models/admin";
import { AdminState } from "../states/admin.state";
import { AdminActions, EAdminActions } from "../actions/admin.action";

export function AdminReducers(
  state: IAdmin = AdminState,
  action: AdminActions,
): IAdmin {
  switch (action.type) {
    case EAdminActions.FetchAuctionsListAttempt: {
      return {
        ...state,
        auctionsList: {
          isLoading: true,
          data: [],
        },
      };
    }

    case EAdminActions.FetchAuctionsListSuccess: {
      return {
        ...state,
        auctionsList: {
          isLoading: false,
          data: action.payload,
        },
      };
    }

    case EAdminActions.FetchAuctionsListFailed: {
      return {
        ...state,
        auctionsList: {
          isLoading: false,
        },
      };
    }

    case EAdminActions.FetchAuctionAttempt: {
      return {
        ...state,
        auction: {
          isLoading: true,
          data: {},
        },
        updateAuction: {
          isUpdated: false,
        },
      };
    }

    case EAdminActions.FetchAuctionSuccess: {
      return {
        ...state,
        auction: {
          isLoading: false,
          data: action.payload,
        },
      };
    }

    case EAdminActions.FetchAuctionFailed: {
      return {
        ...state,
        auction: {
          isLoading: false,
        },
      };
    }

    case EAdminActions.UpdateAuctionAttempt: {
      return {
        ...state,
        updateAuction: {
          isLoading: true,
          isUpdated: false,
        },
      };
    }

    case EAdminActions.UpdateAuctionSuccess: {
      return {
        ...state,
        updateAuction: {
          isLoading: false,
          isUpdated: true,
        },
      };
    }

    case EAdminActions.UpdateAuctionFailed: {
      return {
        ...state,
        updateAuction: {
          isLoading: false,
          isUpdated: false,
        },
      };
    }

    case EAdminActions.FetchBalanceWithdrawListAttempt: {
      return {
        ...state,
        balanceWithdrawList: {
          isLoading: true,
          data: [],
        },
      };
    }

    case EAdminActions.FetchBalanceWithdrawListSuccess: {
      return {
        ...state,
        balanceWithdrawList: {
          isLoading: false,
          data: action.payload,
        },
      };
    }

    case EAdminActions.FetchBalanceWithdrawListFailed: {
      return {
        ...state,
        balanceWithdrawList: {
          isLoading: false,
        },
      };
    }

    case EAdminActions.BalanceWithdrawStatusChangeAttempt: {
      return {
        ...state,
        balanceWithdrawStatusChange: {
          isLoading: true,
          data: [],
        },
      };
    }

    case EAdminActions.BalanceWithdrawStatusChangeSuccess: {
      return {
        ...state,
        balanceWithdrawStatusChange: {
          isLoading: false,
          data: action.payload,
          isUpdated: true,
        },
      };
    }

    case EAdminActions.BalanceWithdrawStatusChangeFailed: {
      return {
        ...state,
        balanceWithdrawStatusChange: {
          data: [],
          isLoading: false,
        },
      };
    }

    case EAdminActions.FetchUserDataAttempt: {
      return {
        ...state,
        userData: {
          isLoading: true,
          data: [],
        },
      };
    }

    case EAdminActions.FetchUserDataSuccess: {
      return {
        ...state,
        userData: {
          isLoading: false,
          data: action.payload,
        },
      };
    }

    case EAdminActions.FetchUserDataFailed: {
      return {
        ...state,
        userData: {
          isLoading: false,
        },
      };
    }

    case EAdminActions.FetchUnprocessedTransactionsListAttempt: {
      return {
        ...state,
        unprocessedTransactions: {
          isLoading: true,
          data: [],
        },
      };
    }

    case EAdminActions.FetchUnprocessedTransactionsListSuccess: {
      return {
        ...state,
        unprocessedTransactions: {
          isLoading: false,
          data: action.payload,
        },
      };
    }

    case EAdminActions.FetchUnprocessedTransactionsListFailed: {
      return {
        ...state,
        unprocessedTransactions: {
          isLoading: false,
        },
      };
    }

    case EAdminActions.FetchTransactionsListAttempt: {
      return {
        ...state,
        transactionsList: {
          isLoading: true,
          data: {},
        },
      };
    }

    case EAdminActions.FetchTransactionsListSuccess: {
      return {
        ...state,
        transactionsList: {
          isLoading: false,
          data: action.payload,
        },
      };
    }

    case EAdminActions.FetchTransactionsListFailed: {
      return {
        ...state,
        transactionsList: {
          data: {},
          isLoading: false,
        },
      };
    }

    case EAdminActions.RefundPaymentAttempt: {
      return {
        ...state,
        refundPayment: {
          isLoading: true,
          errors: [],
        },
      };
    }

    case EAdminActions.RefundPaymentSuccess: {
      return {
        ...state,
        refundPayment: {
          isLoading: false,
          errors: [],
        },
      };
    }

    case EAdminActions.RefundPaymentFailed: {
      return {
        ...state,
        refundPayment: {
          isLoading: false,
          errors: action.payload,
        },
      };
    }

    case EAdminActions.RefundedPaymentAttempt: {
      return {
        ...state,
        refundedPayment: {
          data: {},
          isLoading: true,
        },
      };
    }

    case EAdminActions.RefundedPaymentSuccess: {
      return {
        ...state,
        refundedPayment: {
          data: action.payload,
          isLoading: false,
        },
      };
    }

    case EAdminActions.RefundedPaymentFailed: {
      return {
        ...state,
        refundedPayment: {
          data: {},
          isLoading: false,
        },
      };
    }

    default:
      return state;
  }
}
